import operations from './operations';
import middleware from './middleware';

export default {
  operations,
  middleware,
};
